<template>
  <sf-progress
    v-tooltip.html="tooltipContent"
    :disabled="disabled"
    :pending="pending"
    :sections="sections"
    :show-legend="showLegend"
    show-total-percentage
    size="medium"
  >
    <template #percentage-label>
      <sf-progress-label>
        <sf-progress-percentage-numeric :sections="sections" />
      </sf-progress-label>
    </template>
  </sf-progress>
</template>

<script>
import {
  SfProgress,
  SfProgressLabel,
  SfProgressPercentageNumeric,
} from '@app/shared/vue/components/sf-progress'

export default {
  name: 'WorkflowProgress',
  components: {
    SfProgress,
    SfProgressLabel,
    SfProgressPercentageNumeric,
  },
  props: {
    color: {
      type: String,
      default: 'primary',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    lastId: {
      type: Number,
      required: true,
    },
    ledgerId: {
      type: Number,
      required: true,
    },
    // TODO: Add legend
    showLegend: {
      type: Boolean,
      required: false,
      default: false,
    },
    workflowId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      sections: [],
      pending: true,
    }
  },

  computed: {
    channel() {
      return `/workflow/${this.workflowId}/ledger/${this.ledgerId}/status/${this.I18n.locale}`
    },
    tooltipContent() {
      return this.sections
        .map((section) => {
          return I18n.t(section.i18nKey, {
            completed: section.done,
            total: section.total,
          })
        })
        .join('<br>')
    },
  },

  mounted() {
    window.Silverfin.Polling.subscribe(
      this.channel,
      this.handleMessage,
      this.lastId
    )
  },

  beforeUnmount() {
    window.Silverfin.Polling.unsubscribe(this.channel, this.handleMessage)
  },

  methods: {
    handleMessage(message) {
      // TODO: Get the correct colors from design
      const totals = message.progress

      if (!totals) return

      const sections = [
        {
          i18nKey: 'company_workflows.completion.dimension.todos',
          color: `${this.color}-lighter`,
          total: totals['todos']['total'],
          done: totals['todos']['done'],
        },
        {
          i18nKey: 'company_workflows.completion.dimension.check_links',
          color: `${this.color}-light`,
          total: totals['check_links']['total'],
          done: totals['check_links']['done'],
        },
        {
          i18nKey:
            'company_workflows.completion.dimension.reconciliation_texts',
          color: this.color,
          total: totals['reconciliations']['total'],
          done: totals['reconciliations']['done'],
        },
        {
          i18nKey: 'company_workflows.completion.dimension.account_entries',
          color: `${this.color}-dark`,
          total: totals['account_entries']['total'],
          done: totals['account_entries']['done'],
        },
      ]

      this.sections = sections
      this.pending = false
    },
  },
}
</script>
